module.exports = __webpack_public_path__ + "b3dc303d68963df6911a18724beb3aa2.jpg";